module.exports = __webpack_public_path__ + "img/Zafar.486ca40c.jpg";